/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'react-bootstrap';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UserIcon } from 'assets/img/icons/icons';
import Rating from 'components/base/Rating';
import Button from 'components/base/Button';
import reviewsService from 'service/reviews';

interface AnswerTheReviewProps {
  selectedRow: any;
  refetchProduct: () => void;
  refetchStore: () => void;
  setOpenAnswer: (value: boolean) => void;
}

const AnswerTheReview = ({
  selectedRow,
  refetchProduct,
  refetchStore,
  setOpenAnswer
}: AnswerTheReviewProps) => {
  const { t } = useTranslation();
  const { register, getValues, watch } = useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    const data = {
      parent_id: selectedRow?.guid,
      comment: getValues('info')
    };

    reviewsService
      .createReviewsReplay(data)
      .then(() => {
        refetchProduct();
        refetchStore();
        setOpenAnswer(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Form
        noValidate
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div className="d-flex flex-column">
          <div className="d-flex gap-2 align-items-center mb-2">
            <UserIcon />
            <div className="d-flex flex-column">
              <p className="text-bold p-0 m-0">{selectedRow?.client}</p>
              <Rating
                iconClass="fs-10"
                readonly
                initialValue={selectedRow?.rate}
              />
            </div>
          </div>
          <p className="p-0 m-0 mb-3">{selectedRow?.comments}</p>
          <div
            style={{
              height: '1px',
              width: '100%',
              backgroundColor: '#0000001A',
              marginBottom: '1rem'
            }}
          ></div>

          <div className="form-icon-container">
            <Form.Floating>
              <Form.Control
                {...register('info')}
                id="info"
                as="textarea"
                style={{ height: '115px' }}
                type="text"
                placeholder="info"
                className="form-icon-input"
              />
              <label htmlFor="lastName" className="form-icon-label text-700">
                {t('comments')}
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="text-900 fs-9 form-icon"
            />
          </div>
        </div>

        <Button
          style={{ height: '48px', marginTop: 'auto' }}
          variant="primary"
          type="button"
          loading={loading}
          loadingPosition="start"
          onClick={() => onSubmit()}
          disabled={!watch('info')?.trim() || loading}
        >
          {t('answer')}
        </Button>
      </Form>
    </>
  );
};

export default AnswerTheReview;
